<template>
  <div class="sign-up-form-padding">
    <div v-if="!showLoader" class="form">
      <div class="row padding-form-headline-text">
        <h2>{{ headerTitle }}</h2>
        <div style="text-align: left">{{ headerSubTitle }}</div>
      </div>
      <div
        class="row justify-content-between"
        style="margin-top: 2.0rem!important;"
      >
        <div class="col-6" style="padding-right:.5rem;padding-left:.0rem">
          <div
            @click="logInUsingFacebook"
            class="log-in facebook"
            id="btn-fb-sgn-in-cn"
          >
            <v-icon style="font-size:2.4rem" color="#fff"
              >mdi-facebook-box</v-icon
            ><span style="padding-left:0.5rem; font-size: 1.25rem"
              >Sign up with Facebook</span
            >
          </div>
        </div>
        <div class="col-6" style="padding-left:.5rem;padding-right:.0rem; ">
          <div
            @click="googleSignIn"
            class="log-in google"
            style="color:black"
            id="btn-google-sgn-in-cn"
          >
            <img
              style="width: 2.4rem; height: 2.4rem"
              src="../../assets/newDesign/google.png"
            />
            <span style="padding-left:0.5rem; font-size: 1.25rem;"
              >Sign up with Google</span
            >
          </div>
        </div>
      </div>
      <div v-if="error" class="error-text">
        {{ errorMessage }}
      </div>
      <div style="font-size: 2rem; color: #000000; margin: 0.5rem">-or-</div>
      <v-form ref="form" @submit.prevent="createNewUser" lazy-validation>
        <div class="row">
          <div class="col-12 no-padding">
            <v-text-field
              v-model="firstName"
              label="Name"
              :error-messages="nameErrors"
              style="font-size:1.6rem"
              solo
              outline
            ></v-text-field>
          </div>
        </div>
        <!-- <div class="row">
              <div class="col-sm-12">
                <v-text-field
                  v-model="phone"
                  label="Phone number"
                  :error-messages="phoneErrors"
                
                ></v-text-field>
              </div>
            </div> -->
        <div class="row">
          <div class="col-sm-12 no-padding">
            <v-text-field
              @keydown.space.prevent
              v-model="email"
              @input="email=removeWhiteSpace($event)"
              label="Email"
              :error-messages="emailErrors"
              style="font-size:1.6rem"
              solo
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 no-padding">
            <v-text-field
              ref="password"
              :append-icon="showIcon ? 'visibility' : 'visibility_off'"
              v-model="password"
              :type="showIcon ? 'text' : 'password'"
              name="input-10-1"
              label="Password"
              :error-messages="passwordErrors"
              :hint="hint"
              @click:append="showIcon = !showIcon"
              style="font-size:1.6rem"
              solo
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 no-padding">
            <v-text-field
              v-model="repeatPassword"
              :append-icon="showIcon2 ? 'visibility' : 'visibility_off'"
              label="Re-type Password"
              :type="showIcon2 ? 'text' : 'password'"
              :error-messages="repeatPasswordErrors"
              @click:append="showIcon2 = !showIcon2"
              style="font-size:1.6rem"
              solo
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="row margin-button" style="padding-top:2.0rem !important;">
          <div class="button-sign-in-loader" v-if="showLoader">
            <v-progress-circular
              style="margin-top: 1.0rem;"
              indeterminate
              width="2"
              size="16"
              color="#fff"
            ></v-progress-circular>
          </div>
          <div v-else class="col-sm-12 no-padding">
            <div class="row" style="padding-bottom: 2rem !important;">
              <button class="button-sign-in" id="btn-log-in-cn">Sign Up</button>
            </div>
          </div>
        </div>
        <div class="row phone-mode">
          <div
            class="col-sm-12 no-padding"
            style="text-align:left; font-size:1.6rem; line-height: 1.5; font-weight: 500"
          >
            Already have an account?<span
              ><b class="sign" @click="goToSignIn">Sign in</b> to find your
              perfect job match.</span
            >
          </div>
        </div>
      </v-form>
    </div>
    <div v-else>
      <img src="@/assets/static_content/loader.svg" />
    </div>
    <div>
      <popup-box
        v-on:button-clicked="onSuccessfullySignUp"
        v-bind="popupProps"
        :key="check"
      ></popup-box>
    </div>
  </div>
</template>

<script>
// import MenuBar from "./menu-bar";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
import * as SYSTEM_CONST from "../../globalConstants";
import PopupBox from "../global-components/pop-up-box";
import * as SYSTEM_FILTERS from "../../filters";
import firebase from "firebase/app"
import "firebase/auth"

const phone_validator = helpers.regex(
  "phone_validator",
  /^(?:\+?(?:88|01)?)(?:\d{11}|\d{13})$/
);
export default {
  name: "sign-up",
  components: { PopupBox },
  mixins: [validationMixin],
  validations: {
    firstName: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(64)
    },
    email: {
      required,
      email,
      minLength: minLength(4),
      maxLength: maxLength(64)
    },
    phone: {
      phone_validator,
      minLength: minLength(10),
      maxLength: maxLength(15)
    },
    password: { required, minLength: minLength(8), maxLength: maxLength(12) },
    repeatPassword: { sameAsPassword: sameAs("password") }
  },
  props: {
    job_id: String,
    search_key: String,
    header_title: String,
    header_subtitle: String
  },
  data: function() {
    return {
      showIcon: false,
      showIcon2: false,
      showLoader: false,
      firstName: "",
      email: "",
      phone: "",
      password: "",
      repeatPassword: "",
      popupProps: {
        open: false
      },
      check: 0,
      hint: SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH,
      error: false,
      errorMessage: null,
      headerTitle: this.header_title || "",
      headerSubTitle: this.header_subtitle || ""
    };
  },
  methods: {
    removeWhiteSpace(text) {
      return text.replace(/[\s\/]/g, "");
    },
    logInByFacebook(data) {
      const self = this;
      if (data) {
        self.$store
          .dispatch("oAuthSignUp", data)
          .then(response => {
            if (response.status === 201 || response.status === 200) {
              switch (response.data.user_type) {
                case self.$constants.USER_TYPE.CANDIDATE:
                  if (self.job_id) {
                    self.$router
                      .push({
                        name: "topJobView",
                        params: { q: self.job_id }
                      })
                      .catch(function() {});
                  } else if(self.search_key) {
                    self.$router.push({
                      name: "candidateSearchJobs",
                      params: { q: self.search_key }
                    }).catch(function() {});
                  } else {
                    self.$router
                      .push({ name: "candidate" })
                      .catch(function() {});
                  }
                  break;
                case self.$constants.USER_TYPE.HIRING_MANAGER:
                  self.$router.push({ name: "employer" }).catch(function() {});
                  break;
                default:
                  self.$router
                    .push({ name: "landingPage" })
                    .catch(function() {});
                  break;
              }
            }
          })
          .catch(function() {
            alert("Something went wrong");
          });
      } else {
        alert("Something went wrong");
      }
    },
    logInUsingFacebook() {
      const self = this;
      let provider = new firebase.auth.FacebookAuthProvider();
      provider.addScope('email');
      firebase.auth().signInWithPopup(provider).then(function() {
        firebase.auth().currentUser.getIdToken().then((res)=> {
          let data = {
            oauth: {
              id_token: res
            }
          };
          self.$store.dispatch("oAuthSignUp", data).then(function(response) {
            if (response.status === 200 || response.status === 201) {
              switch (response.data.user_type) {
                case self.$constants.USER_TYPE.CANDIDATE:
                  if (self.job_id) {
                    self.$router.push({name: "topJobView", params: { q: self.job_id }}).catch(function() {});
                  } else if(self.search_key) {
                    self.$router.push({
                      name: "candidateSearchJobs",
                      params: { q: self.search_key }
                    }).catch(function() {});
                  } else {
                    self.$router.push({ name: "candidate" }).catch(function() {});
                  }
                  break;
                case self.$constants.USER_TYPE.HIRING_MANAGER:
                  self.$router.push({ name: "employer" }).catch(function() {});
                  break;
                case self.$constants.USER_TYPE.ADMIN:
                  self.$router.push({ name: "admin" }).catch(function() {});
                  break;
                default:
                  self.$router.push({ name: "landingPage" }).catch(function() {});
                  break;
              }
            } else {
              self.showLoader = false;
              self.error = true;
              self.errorMessage = SYSTEM_CONST.SIGN_IN.FAILURE + FILTER.FIRST_LETTER_CAPITAL(response.data.message);
            }
          }).catch(function(err) {
            self.showLoader = false;
            self.error = true;
            self.errorMessage = SYSTEM_CONST.SIGN_IN.FAILURE + err.message;
          });
          firebase.auth().signOut().then(function() {}).catch(function() {});
        })
      }).catch(function(err) {
        if(err.code !== 'auth/popup-closed-by-user' || err.code !== 'auth/cancelled-popup-request') {
          self.error = true;
          if(err.credential) {
            if (err.credential.providerId.toUpperCase().includes('FACEBOOK')) {
              self.errorMessage = 'An account already exists with the same email address. ' +
                      'Sign in with Google associated with this email address.'
            } else {
              self.errorMessage = err.message;
            }
          }  else {
            self.errorMessage = err.message;
          }
        }
      });
    },
    googleSignIn() {
      const self = this;
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      firebase.auth().signInWithPopup(provider).then(function() {
        firebase.auth().currentUser.getIdToken().then((res)=> {
          let data = {
            oauth: {
              id_token: res
            }
          };
          self.$store.dispatch("oAuthSignUp", data).then(function(response) {
            if (response.status === 200 || response.status === 201) {
              switch (response.data.user_type) {
                case self.$constants.USER_TYPE.CANDIDATE:
                  if (self.job_id) {
                    self.$router.push({name: "topJobView", params: { q: self.job_id }}).catch(function() {});
                  } else if(self.search_key) {
                    self.$router.push({
                      name: "candidateSearchJobs",
                      params: { q: self.search_key }
                    }).catch(function() {});
                  } else {
                    self.$router.push({ name: "candidate" }).catch(function() {});
                  }
                  break;
                case self.$constants.USER_TYPE.HIRING_MANAGER:
                  self.$router.push({ name: "employer" }).catch(function() {});
                  break;
                case self.$constants.USER_TYPE.ADMIN:
                  self.$router.push({ name: "admin" }).catch(function() {});
                  break;
                default:
                  self.$router.push({ name: "landingPage" }).catch(function() {});
                  break;
              }
            } else {
              self.showLoader = false;
              self.error = true;
              self.errorMessage = SYSTEM_CONST.SIGN_IN.FAILURE + FILTER.FIRST_LETTER_CAPITAL(response.data.message);
            }
          }).catch(function(err) {
            self.showLoader = false;
            self.error = true;
            self.errorMessage = SYSTEM_CONST.SIGN_IN.FAILURE + err.message;
          });
          firebase.auth().signOut().then(function() {}).catch(function() {});
        })
      }).catch(function(err) {
        if(err.code !== 'auth/popup-closed-by-user' || err.code !== 'auth/cancelled-popup-request') {
          self.error = true;
          if(err.credential) {
            if (err.credential.providerId.toUpperCase().includes('FACEBOOK')) {
              self.errorMessage = 'An account already exists with the same email address. ' +
                      'Sign in with Google associated with this email address.'
            } else {
              self.errorMessage = err.message;
            }
          }  else {
            self.errorMessage = err.message;
          }
        }
      });
    },
    goToSignIn: function() {
      this.$router.push({ name: "signin" }).catch(function() {});
    },
    createNewUser: function() {
      const self = this;
      self.firstName = SYSTEM_FILTERS.REMOVE_WHITE_SPACES(self.firstName);
      self.$v.$touch();
      if (!self.$v.$anyError) {
        self.$emit("clicked",true)
        self.error = false;
        self.errorMessage = null;
        let user = {
          user_name: self.firstName,
          email: self.email,
          password: self.password
        };
        self.showLoader = true;
        self.$store
          .dispatch("signUp", user)
          .then(function(response) {
            if (response.status === 201 || response.status === 200) {
              self.showLoader = false;
              switch (response.data.user_type) {
                case self.$constants.USER_TYPE.CANDIDATE:
                  if (self.job_id) {
                    self.$router
                      .push({
                        name: "topJobView",
                        params: { q: self.job_id }
                      })
                      .catch(function() {});
                  } else {
                    self.$router
                      .push({ name: "candidate" })
                      .catch(function() {});
                  }
                  break;
                case self.$constants.USER_TYPE.HIRING_MANAGER:
                  self.$router.push({ name: "employer" }).catch(function() {});
                  break;
                default:
                  self.$router
                    .push({ name: "landingPage" })
                    .catch(function() {});
                  break;
              }
            } else {
              self.$emit("clicked",false);
              self.showLoader = false;
              self.error = true;
              self.errorMessage = response.message;
            }
          })
          .catch(function onError(err) {
            self.$emit("clicked",false);
            self.showLoader = false;
            self.error = true;
            self.errorMessage = err.response.data.message;
          });
      }
    },
    onSuccessfullySignUp: function() {
      const self = this;
      if (self.error) {
        self.$router.push({ name: "signup" }).catch(function() {});
      } else {
        self.$router.push({ name: "landingPage" }).catch(function() {});
      }
    }
  },
  mounted() {
    const self = this;
    if (self.$route&&self.$route.query.email) {
      self.email = self.$route.query.email;
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.NAME);
      !this.$v.firstName.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.NAME);
      !this.$v.firstName.required &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.EMAIL_INVALID);
      !this.$v.email.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.EMAIL_INVALID);
      !this.$v.email.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.EMAIL_INVALID);
      !this.$v.email.required &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.phone.phone_validator &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PHONE_INVALID);
      !this.$v.phone.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PHONE_INVALID);
      !this.$v.phone.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PHONE_INVALID);
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.password.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.password.required &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_NOT_MATCH);
      return errors;
    }
  },
};
</script>

<style scoped>
.error-text{
  margin: 1rem 0;
  text-align: left;
  color: var(--button-delete-color);
}
.log-in {
  border-radius: 0.4rem;
  padding: 0.5rem;
  text-align: center;
  cursor: pointer;
  width: 100%;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.google {
  border: solid 0.2rem #eeeeee;
  background-color: #eeeeee;
}
.facebook {
  border: solid 0.2rem #4267b2;
  background-color: #4267b2;
}
.button {
  color: white;
  width: 100%;
  padding: 1rem;
  height: 4.4rem;
  border-radius: 0.8rem;
  background-color: var(--button-color);
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
}
.margin-button {
  padding-bottom: 3rem !important;
}

.form {
  border-radius: 0.2rem;
}
.v-input {
  text-align: right !important;
}
.headline-text {
  text-align: left;
  font-size: 2.8rem;
  font-weight: bold;
  line-height: 1.25;
  color: #050405;
}
.sign-up-form-padding {
  width: 36.4rem;
}

@media (max-width: 60rem) {
  .sign-up-form-padding {
    width: 100%;
    padding: 1rem 2.4rem;
  }
}
.padding-form-headline-text {
  padding-top: 2rem !important;
  padding-bottom: 1rem !important;
}
.sign {
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: left;
  color: var(--link-color);
  cursor: pointer;
  margin-left: 0.5rem;
}
.button-sign-in-loader {
  margin: auto;
  width: 36.4rem;
  height: 3.8rem;
  border-radius: 0.8rem;
  background-color: var(--button-color);
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}
</style>
